import {Component, Input} from '@angular/core';
import {CategoryItem, Country, League, LeagueRaceType, LeagueStandingsMeta, LeagueStandingsViewMode} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {LeagueStandingsService, LoaderService} from "@services";
import {AbstractComponent} from "@components";

@Component({
  selector: 'app-league-overall-results',
  templateUrl: './league-overall-results.component.html',
  styleUrl: './league-overall-results.component.scss',
  standalone: false,
})
export class LeagueOverallResultsComponent extends AbstractComponent{

  @Input() league: League | undefined;
  @Input() categoryItems: CategoryItem[] = [];
  @Input() competitorsCountries: Country[] = [];
  @Input() standingsMeta: LeagueStandingsMeta[] = [];

  availableRaceTypesDraft: LeagueRaceType[] = [];
  availableRaceTypesPublic: LeagueRaceType[] = [];
  currentStandingsPublicMeta: LeagueStandingsMeta | undefined;
  currentStandingsDraftMeta: LeagueStandingsMeta | undefined;

  activeViewMode = LeagueStandingsViewMode.DRAFT;
  activeRaceType = LeagueRaceType.INDIVIDUAL;
  publicIncluded: string[] = [];
  draftIncluded: string[] = [];
  standingsViewOptions = [
    {
      value: LeagueStandingsViewMode.DRAFT,
      label: 'league.standings.viewMode.DRAFT'
    },
    {
      value: LeagueStandingsViewMode.PUBLIC,
      label: 'league.standings.viewMode.PUBLIC'
    }
  ];

  constructor(
      public translocoService: TranslocoService,
      private leagueStandingsService: LeagueStandingsService,
      private loaderService: LoaderService) {
    super();
  }

  ngOnInit() {
    this.standingsMeta.forEach(meta => {
      if (!meta.raceType) return;
      if (meta.metaType === LeagueStandingsViewMode.DRAFT) {
        this.availableRaceTypesDraft.push(meta.raceType);
      } else {
        this.availableRaceTypesPublic.push(meta.raceType);
      }
    });
    this.changeRaceType(this.availableRaceTypesDraft.at(0) ?? LeagueRaceType.INDIVIDUAL)
  }

  changeRaceType(raceType: LeagueRaceType) {
    this.activeRaceType = raceType;
    this.updateStandingsMeta(raceType);
  }

  setActiveViewMode(viewMode: LeagueStandingsViewMode) {
    this.activeViewMode = viewMode;
  }

  private updateStandingsMeta(raceType: LeagueRaceType | undefined) {
    this.currentStandingsPublicMeta = this.standingsMeta.find(meta =>
        meta.raceType === raceType && meta.metaType === LeagueStandingsViewMode.PUBLIC
    );
    this.currentStandingsDraftMeta = this.standingsMeta.find(meta =>
        meta.raceType === raceType && meta.metaType === LeagueStandingsViewMode.DRAFT
    );

    const roundLabel = this.translocoService.translate('event.item.round')?.[0]?.toUpperCase() ?? '';

    const publicIncludedSet: Set<string> = new Set<string>();
    const draftIncludedSet: Set<string> = new Set<string>();
    this.currentStandingsPublicMeta?.racesApplied?.forEach(r => {
      publicIncludedSet.add(`${roundLabel}${r?.round ?? ''}`);
    });
    this.currentStandingsDraftMeta?.racesApplied?.forEach(r => {
      draftIncludedSet.add(`${roundLabel}${r?.round ?? ''}`);
    });
    this.publicIncluded = Array.from(publicIncludedSet);
    this.draftIncluded = Array.from(draftIncludedSet);
  }

  protected readonly LeagueStandingsViewMode = LeagueStandingsViewMode;

}
